__turbopack_context__.v({
  "latest_news_thumbnail": "Xdv-3q_latest_news_thumbnail",
  "latest_news_thumbnail_image": "Xdv-3q_latest_news_thumbnail_image",
  "latest_news_thumbnail_overlay": "Xdv-3q_latest_news_thumbnail_overlay",
  "latest_news_thumbnail_overlay_source": "Xdv-3q_latest_news_thumbnail_overlay_source",
  "latest_news_thumbnail_overlay_story": "Xdv-3q_latest_news_thumbnail_overlay_story",
  "latest_news_thumbnail_wrapper": "Xdv-3q_latest_news_thumbnail_wrapper",
});
